// extracted by mini-css-extract-plugin
export default {"breadcrumbsWrapper":"breadcrumbs_breadcrumbsWrapper__goMXc","backButton":"breadcrumbs_backButton__WkKDd","breadcrumbs":"breadcrumbs_breadcrumbs__sXKsq"};